var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{staticClass:"d-inline-block mx-md-3"},[(_vm.accountId)?_c('h2',[_vm._v("("+_vm._s(_vm.accountTypeDisplayCopy)+")")]):_vm._e()])}
var staticRenderFns = []

export { render, staticRenderFns }